import {
  accountingDefaults,
  basicDetailsDefaults,
  detailsDefaults,
  pocDefaults,
  typeOfWorkDefaults,
} from '../schema/defaultValues';

function collectFieldPaths(obj, prefix = '') {
  // undefined = no field
  if (obj === undefined) return [];

  // null OR primitive = leaf field
  if (obj === null || typeof obj !== 'object') {
    return prefix ? [prefix] : [];
  }

  // arrays = validate as a unit
  if (Array.isArray(obj)) {
    return prefix ? [prefix] : [];
  }

  // objects = recurse
  return Object.entries(obj).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    return collectFieldPaths(value, path);
  });
}

export const STEP_DEFAULTS_MAP = {
  basic: basicDetailsDefaults,
  sanction: {},
  type: typeOfWorkDefaults,
  poc: pocDefaults,
  accounting: accountingDefaults,
};

/** Field paths under the `details` branch (work_jobs2), by the step that renders them. */
const detailPaths = (...keys: string[]) =>
  keys.flatMap((key) => collectFieldPaths(detailsDefaults.details[key], `details.${key}`));

export const DETAIL_FIELDS_BY_STEP = {
  sanction: detailPaths('sanction', 'sanctioningAuthority', 'quotation'),
  type: detailPaths('alliedWorkDetails'),
  accounting: detailPaths('documentReferenceNumber', 'accountingNotes'),
};

export const STEP_FIELD_MAP = Object.fromEntries(
  Object.entries(STEP_DEFAULTS_MAP).map(([step, defaults]) => [
    step,
    [...collectFieldPaths(defaults), ...(DETAIL_FIELDS_BY_STEP[step] ?? [])],
  ]),
);

export const ALL_FIELDS = Array.from(new Set(Object.values(STEP_FIELD_MAP).flat()));
